import { useActiveGlassesIndex } from '@order/hooks/useActiveOrderItem'
import { useFrameDetails } from '@frame/Frame/useFrameDetails'
import FrameTile from '@frame/Frame/FrameTile'
import MeasurementUtils from 'utils/MeasurementUtils'
import { useTranslation } from 'react-i18next'
import { Detail } from '@frame/Frame/types'

export default function FrameDetails() {
  const { t } = useTranslation(['common'])
  const SH = t('common:sh')

  const { index, frame } = useActiveGlassesIndex()
  const { details } = useFrameDetails(frame, { hideQty: true })

  const sh = MeasurementUtils.parse.sh.measurementsOrEmpty(frame?.measurement)

  if (!frame) return null

  const x = frame.shape.extend_x
  const y = frame.shape.extend_y

  const extras = [
    [`${SH} R`, sh?.right?.toFixed(2)],
    [`${SH} L`, sh?.left?.toFixed(2)],
    ['X', x?.toFixed(2)],
    ['Y', y?.toFixed(2)],
  ] satisfies Detail[]

  return (
    <>
      <FrameTile
        type="frame"
        image={frame.url}
        title={frame.default_code}
        details={details}
        extras={extras}
        variant="default"
      />
    </>
  )
}
